// ContactPage.tsx — wraps reused ContactUs component
import React from 'react'
import { Helmet } from 'react-helmet-async'
import ContactUs from '../components/ContactUs'

interface Props {
  dark: boolean
  apiBase: string
  productUrl: string
}

const ContactPage: React.FC<Props> = ({ dark, apiBase }) => {
  // Pass apiBase from props so ContactUs resolves the correct backend URL.
  // It comes from VITE_API_URL (App.tsx), which this project leaves EMPTY in
  // both dev and prod — so the URL is relative ('/api/contact') and reaches the
  // backend same-origin through the Vite proxy in dev and nginx in prod. No
  // CORS, no preflight, and nothing pointing at localhost in a shipped bundle.
  return (
    <>
      <Helmet>
        <title>Contact Us — Larxnet</title>
        <meta name="description" content="Get in touch with the Larxnet team. We're here to help with questions about our enterprise analytics platform." />
      </Helmet>
      <div className="page-enter">
        <ContactUs dark={dark} apiBase={apiBase} />
      </div>
    </>
  )
}

export default ContactPage
